import React from 'react';
import { CtaButton } from './CtaButton';
import { PriceDisplay } from './PriceDisplay';
export function UrgencyClose() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10" data-id="element-450">
      <hr className="border-t-2 border-dashed border-border-light mb-10" data-id="element-451" />

      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-6" data-id="element-452">
        La Oferta Especial de Lanzamiento Se Cierra Pronto:
      </h2>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-453">
        Déjame advertirte una vez más:{' '}
        <strong data-id="element-454">esta oferta especial de lanzamiento se cerrará pronto</strong> y
        no podrás acceder a este precio después, aunque quieras.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-455">
        Porque el Pack Estimulación Temprana pronto tendrá su precio regular de{' '}
        <strong data-id="element-456">
          <PriceDisplay amount={36} data-id="element-457" />
        </strong>
        .
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-458">
        Pero AQUÍ... en ESTA página... el precio es un pago único de solo{' '}
        <span className="text-primary font-bold text-2xl" data-id="element-459">
          <PriceDisplay amount={12.99} data-id="element-460" />
        </span>
        . Y esta página desaparecerá muy pronto. Me reservo el derecho de cerrar
        este descuento en cualquier momento sin previo aviso después del 25 de
        febrero de 2026.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-461">
        Así que tienes una decisión que tomar.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-462">
        ¡Y creo que la decisión es fácil!
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-463">
        <strong data-id="element-464">Por el precio de un par de cafés</strong>, puedes eliminar TODAS
        las dudas, la culpa y el estrés de no saber cómo estimular correctamente
        a tu hijo/a — PARA SIEMPRE.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-465">
        Piensa en todo el <strong data-id="element-466">tiempo, energía y dinero</strong> que
        ahorrarás con una colección de más de 1.000 actividades al alcance de tu
        mano.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-467">
        Mejor aún, después de tu pedido recibirás{' '}
        <strong data-id="element-468">ACCESO INMEDIATO</strong> a todo el pack. No hay que esperar
        envíos. Puedes tener la información que necesitas en cuestión de
        segundos.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-469">
        Con cientos de familias felices, es momento de que tú también te sumes.
        Así que no pierdas más tiempo.
      </p>

      <p className="text-center font-serif text-lg font-bold text-dark mb-6" data-id="element-470">
        Actúa ahora mismo:
      </p>

      <div className="text-center my-8" data-id="element-471">
        <CtaButton size="large" subtitle="Empieza Hoy Mismo >>" data-id="element-472">
          Añadir Al Carrito
        </CtaButton>
      </div>

      <p className="font-sans text-sm text-gray-500 text-center mb-8" data-id="element-473">
        Pago único. Me reservo el derecho de cerrar este descuento en cualquier
        momento sin previo aviso después del 25 de febrero de 2026.
      </p>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-474">
        En cuanto hagas clic en "Añadir Al Carrito", recibirás un email con tu
        acceso de descarga.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-475">
        Podrás descargar el <strong data-id="element-476">Pack Estimulación Temprana</strong> completo
        con las +1.000 actividades y todos los bonos ahora mismo.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-477">
        Puedes estar revisando las guías en solo unos minutos y empezar con tu
        primera actividad inmediatamente.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-478">
        Experimenta la alegría... la satisfacción... de saber con{' '}
        <strong data-id="element-479">100% de certeza</strong> que estás dando a tu hijo/a exactamente
        lo que necesita en cada etapa de su desarrollo.
      </p>
      <p className="font-serif text-lg text-body-text mb-8 leading-relaxed" data-id="element-480">
        Todo lo que tienes que hacer para empezar es hacer clic en el botón de
        abajo:
      </p>

      {/* Final Price Box */}
      <div className="bg-gradient-to-br from-[#FFF8E1] to-highlight-bg border-[3px] border-primary rounded-2xl py-9 px-6 md:px-8 text-center my-10" data-id="element-481">
        <p className="font-sans text-sm uppercase tracking-[2px] text-primary font-bold mb-2" data-id="element-482">
          PRECIO DE HOY:
        </p>
        <PriceDisplay amount={12.99} className="font-sans text-5xl md:text-6xl font-black text-primary block my-4" data-id="element-483" />

        <div className="my-6" data-id="element-484">
          <CtaButton size="large" subtitle="Comienza Tu Primera Actividad Hoy >>" data-id="element-485">
            Añadir Al Carrito
          </CtaButton>
        </div>

        <p className="font-sans text-sm text-gray-500" data-id="element-486">
          Pago único. Sin cuotas mensuales.
        </p>
      </div>

      {/* P.S. Sections */}
      <div className="bg-light-bg py-6 px-6 rounded-lg my-8" data-id="element-487">
        <p className="font-serif text-base text-body-text leading-relaxed" data-id="element-488">
          <strong data-id="element-489">P.D.:</strong> Recuerda... tienes mi{' '}
          <strong data-id="element-490">
            Garantía 100% Sin Riesgo e Incondicional de Devolución de Dinero
          </strong>
          . Estoy 110% seguro/a de que estarás más feliz que un niño la mañana
          de Navidad con tus guías. Pero si por cualquier razón no lo estás, no
          te preocupes. Tu inversión está protegida durante 30 días completos.
        </p>
      </div>

      <div className="bg-light-bg py-6 px-6 rounded-lg my-8" data-id="element-491">
        <p className="font-serif text-base text-body-text leading-relaxed" data-id="element-492">
          <strong data-id="element-493">P.P.D.:</strong> ¡Esta es una OFERTA CON TIEMPO LIMITADO! No
          volverás a tener la oportunidad de adquirir este pack a este precio
          una vez que la oferta introductoria termine. El precio subirá a 36,00
          € y NO habrá vuelta atrás.
        </p>
      </div>
    </div>;
}